import React from 'react';

interface HomeLayoutShellProps {
  children: React.ReactNode;
}

// 首页强制布局容器：内容区宽度 461px ~ 1440px，四周预留 24px 水平空白
export const HomeLayoutShell: React.FC<HomeLayoutShellProps> = ({ children }) => {
  return (
    <div
      className="relative mx-auto w-full px-6"
      style={{ minWidth: '509px', maxWidth: '1488px' }}
    >
      {children}
    </div>
  );
};
